import { SocialIcon } from '@/components/iconify';
import { Form, Field } from '@/components/hook-form';

import LoadingButton from '@mui/lab/LoadingButton';
import { Box, InputAdornment } from '@mui/material';

export default function LegacyLinksForm({ methods, onSubmit, submitting, isSubmitting }) {
  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Field.Text
          name="facebook"
          label="Facebook"
          placeholder="https://www.facebook.com/username"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SocialIcon width={24} icon="facebook" />
              </InputAdornment>
            ),
          }}
        />

        <Field.Text
          name="instagram"
          label="Instagram"
          placeholder="https://www.instagram.com/username"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SocialIcon width={24} icon="instagram" />
              </InputAdornment>
            ),
          }}
        />

        <Field.Text
          name="linkedin"
          label="Linkedin"
          placeholder="https://www.linkedin.com/in/username"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SocialIcon width={24} icon="linkedin" />
              </InputAdornment>
            ),
          }}
        />

        <Field.Text
          name="twitter"
          label="Twitter"
          placeholder="https://www.twitter.com/username"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SocialIcon width={24} icon="twitter" />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <LoadingButton
          color="inherit"
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting || submitting}
        >
          Save changes
        </LoadingButton>
      </Box>
    </Form>
  );
}
